// src/Agenda.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Agenda_default = createIcon({
  displayName: "Agenda",
  viewBox: "0 0 24 25",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "25", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M2.1001 7.03599C2.1001 6.53893 2.50304 6.13599 3.0001 6.13599H21.0001C21.4972 6.13599 21.9001 6.53893 21.9001 7.03599V17.9646C21.9001 18.4616 21.4972 18.8646 21.0001 18.8646H3.0001C2.50304 18.8646 2.1001 18.4616 2.1001 17.9646V7.03599ZM3.9001 7.93599V17.0646H20.1001V7.93599H3.9001Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M5.95715 10.8932C5.95715 10.3961 6.3601 9.99316 6.85715 9.99316H17.1429C17.6399 9.99316 18.0429 10.3961 18.0429 10.8932C18.0429 11.3902 17.6399 11.7932 17.1429 11.7932H6.85715C6.3601 11.7932 5.95715 11.3902 5.95715 10.8932Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor",
        d: "M5.95715 14.1075C5.95715 13.6105 6.3601 13.2075 6.85715 13.2075H13.9286C14.4256 13.2075 14.8286 13.6105 14.8286 14.1075C14.8286 14.6046 14.4256 15.0075 13.9286 15.0075H6.85715C6.3601 15.0075 5.95715 14.6046 5.95715 14.1075Z"
      }
    )
  ] })
});

export {
  Agenda_default
};
